import styled from 'styled-components';
import { compose, color, space, typography, layout, display, border, flexbox, position, variant } from 'styled-system';
import { c as colors } from './variables-80f55df9.js';

var StyledButtonVariant;
(function (StyledButtonVariant) {
    StyledButtonVariant["CTA"] = "cta";
    StyledButtonVariant["primary"] = "primary";
    StyledButtonVariant["outline"] = "outline";
})(StyledButtonVariant || (StyledButtonVariant = {}));
var StyledButton = styled.button(compose(color, space, typography, layout, display, border, flexbox, position), function (props) {
    var _a;
    return variant({
        variants: (_a = {},
            _a[StyledButtonVariant.CTA] = {
                bg: colors.primary,
                color: colors.white,
                ":hover": {
                    color: colors.white,
                    "text-decoration": "none",
                },
            },
            _a[StyledButtonVariant.primary] = {
                bg: colors.secondary800,
                color: colors.white,
                ":hover": {
                    color: colors.white,
                    "text-decoration": "none",
                },
            },
            _a[StyledButtonVariant.outline] = {
                bg: colors.white,
                color: props.color,
                border: "1px solid ".concat(props.color),
                ":hover": {
                    color: colors.turquoise100,
                    "text-decoration": "none",
                },
            },
            _a),
    });
});
StyledButton.defaultProps = {
    borderRadius: 4,
    mt: 12,
    py: 8,
    px: 60,
    height: "fit-content",
    textAlign: "center",
};

export { StyledButtonVariant as S, StyledButton as a };
//# sourceMappingURL=StyledButton-81443684.js.map
